import * as React from "react";
import "./MenuIconButton.component.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
export function MenuIconButton({ mainIcon, subIcon, mainTooltip, subTooltip, onClick, onSubIconClick }) {
    return (React.createElement("div", { className: "menu-icon-button-container" },
        React.createElement("button", { className: "icon-button-large menu-icon-button-main", onClick: onClick, "data-tooltip": mainTooltip },
            React.createElement(FontAwesomeIcon, { icon: ["fas", mainIcon] })),
        React.createElement("button", { className: "icon-button menu-icon-button-sub", onClick: onSubIconClick, "data-tooltip": subTooltip },
            React.createElement(FontAwesomeIcon, { icon: ["fas", subIcon || "cog"] }))));
}
